import { useParams } from "react-router-dom";
import ListYourShowForm from "./ListYourShowForm.jsx";

/**
 * Organizer edit uses the same multi-step create form (Add Event).
 * Loads existing event via eventId and submits with PUT update.
 */
export default function ListYourShowEdit() {
  const { id } = useParams();
  const viewPath = `/listyourshow/view/${id}`;
  return (
    <ListYourShowForm
      eventId={id}
      successRedirect={viewPath}
      exitTo={viewPath}
    />
  );
}
